import { render } from "./ColorRange.vue?vue&type=template&id=cd382120&scoped=true"
import script from "./ColorRange.vue?vue&type=script&lang=js"
export * from "./ColorRange.vue?vue&type=script&lang=js"

import "./ColorRange.vue?vue&type=style&index=0&id=cd382120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd382120"]])

export default __exports__